import {
    SET_LAST_SEARCH_CRITERIA,
} from "../actions/types";

const initialState = [];
const cmsReducer = function (state=initialState, action) {
    const {type, payload } = action;
    switch (type) {
        case SET_LAST_SEARCH_CRITERIA:
            return {
                ...state,
                lastSearchCriteria:payload
            }
       
        default:
            return state;
    }
};

export default cmsReducer;